module.exports = __webpack_public_path__ + "img/AlbumReview.f8486f27.jpg";